const getQueryStep = (): number | undefined => {
  if (typeof window === 'undefined') return 1;

  const queryParams = new URLSearchParams(window.location.search);
  const stepFromQuery = queryParams.get('step');

  if (!stepFromQuery) return undefined;

  const step = parseInt(stepFromQuery) || undefined;

  return step;
};

export default getQueryStep;
